import { Layout } from 'antd';
import React from 'react';
import styled from 'styled-components';
const { Content } = Layout;
/**
 ** 내용 감싸는 컨테이너
 */

interface IProps {
  children: JSX.Element | JSX.Element[];
}

const ContentComponent = ({ children }: IProps) => {
  return <Container>{children}</Container>;
};

export default ContentComponent;

const Container = styled(Content)<IProps>`
  padding: 0rem 0rem;
  /* margin-top: 4rem; */
  /* padding: 1.5rem 3.5rem 3rem; */
`;
